export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10597.82b80c07.jpg";